import L from "leaflet";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { Marker, Popup, useMapEvents } from "react-leaflet";
import Api, { API_GEOSERVER_URI } from "../../../api2";
import { ThongBao } from "../../Lib/componentLibrarys";
// import { ThongBao } from '../../CapPhepVaDoiTuong/componentLibrarys';
// import icon from '../../../../assets/images/kk_1.png';

// var popup = L.popup({ offset: [0, -30]});
// var myIcon = L.icon({
//   iconUrl: icon,
//   iconAnchor: [13, 35],
// });

export default function DoiTuongKiemKeMarker({
  valuePosition,
  valueData,
  setOffShowDataSearchList
}) {
  const [position, setPosition] = useState(valuePosition);
  const [data, setData] = useState(valueData);
  const markerRef = useRef(null);

  useEffect(() => {
    setPosition(valuePosition === 1 ? null : valuePosition);

    setData(valueData);
  }, [valuePosition]);

  const map = useMapEvents({
    click: e => {
      setPosition(e.latlng);
      const latlng = e.latlng;
      const params = {
        request: "GetFeatureInfo",
        service: "WMS",
        srs: "EPSG:4326",
        styles: "",
        transparent: true,
        version: "1.1.1",
        format: "image/png",
        bbox: map.getBounds().toBBoxString(),
        height: map.getSize().y,
        width: map.getSize().x,
        layers: "CaChinhBong:VungSanXuat",
        exceptions: "application%2Fvnd.ogc.se_inimage",
        query_layers: "CaChinhBong:VungSanXuat",
        info_format: "application/json",
        feature_count: 1,
        x: Math.round(map.latLngToContainerPoint(latlng).x),
        y: Math.round(map.latLngToContainerPoint(latlng).y)
      };
      // Construct the GetFeatureInfo URL
      const url = API_GEOSERVER_URI + L.Util.getParamString(params);
      // Send the GetFeatureInfo request
      fetch(url)
        .then(response => response.text())
        .then(data => {
          // Handle the GetFeatureInfo response data here
          const parsedData = JSON.parse(data);
          if (
            !parsedData?.numberReturned &&
            !isEmpty(parsedData?.features?.[0]?.properties)
          ) {
            setPosition(null);
            return;
          }
          setData(parsedData?.features?.[0]?.properties);
        })
        .catch(error => {
          console.error(error);
        });
    }
  });

  useEffect(() => {
    if (data && position && markerRef.current) {
      markerRef.current.openPopup();
    }
  }, [data]);

  const openInNewTab = url => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  if (!data || !position) return;

  const tinhThanhString = data?.TinhThanh ? data.TinhThanh : ''
  const quanHuyenString = data?.QuanHuyen ? data.QuanHuyen + ', ' : ''
  const phuongXaString = data?.PhuongXa ? data.PhuongXa + ', ' : ''
  const diaChiChiTietString = data?.diachi ? data.diachi + ', ' : ''

  data.diaChiString = diaChiChiTietString + phuongXaString + quanHuyenString + tinhThanhString;

  return (
    <Marker position={position} ref={markerRef}>
      <Popup minWidth={"100%"}>
        <div>
          <p className="dataPopupMap-title">THÔNG TIN VÙNG SẢN XUẤT</p>
          <div className="dataPopupMap-boxItem">
            <p className="dataPopupMap-item-title">
              Tên vùng sản xuất:{" "}
              <span className="dataPopupMap-item-content">
                {data?.TenVungSanXuat}
              </span>
            </p>
            <p className="dataPopupMap-item-title">
              Diện tích:{" "}
              <span className="dataPopupMap-item-content">
                {data?.DienTich
                  ? String(data?.DienTich || 0).replace(".", ",").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
                  : "-/-"}
                <span>m</span>
                <sup>2</sup>
              </span>
            </p>
            <p className="dataPopupMap-item-title">
              Địa chỉ chi tiết:{" "}
              <span className="dataPopupMap-item-content">
                {data?.diaChiString}
              </span>
            </p>
            <p className="dataPopupMap-item-title">
              Mô tả:{" "}
              <span className="dataPopupMap-item-content">
                {data?.ThongTinMoTa}
              </span>
            </p>
            <p className="dataPopupMap-item-title">
              Ghi chú:{" "}
              <span className="dataPopupMap-item-content">
                {data?.GhiChu}
              </span>
            </p>
          </div>
          <p
            style={{
              color: "#40A7DE",
              fontStyle: "italic",
              cursor: "pointer",
              textDecoration: "underline",
              margin: "7px",
              // width: "160px"
            }}
            onClick={() => openInNewTab(`vungsanxuat/edit/${data?.Id}`)}
          >
            Chỉnh sửa thông tin chi tiết
          </p>
        </div>
      </Popup>
    </Marker>
  );
}
